<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAiAssistant_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <g fill="currentColor" clip-path="url(#IconAiAssistant_16__a)">
        <path
            d="M5.143 12.017V6h1.016q.111 0 .222.025t.222.058L11 7.8a.7.7 0 0 1 .357.3.84.84 0 0 1 .135.45.74.74 0 0 1-.23.567.75.75 0 0 1-.532.216H9.063a.6.6 0 0 1-.119-.008.4.4 0 0 1-.103-.042l-1.016-.416-.206.65 1.222.45q.032.016.095.025Q9 10 9.048 10h4.349q.508 0 .889.383.38.384.38.95l-5.063 2zm-3.81 1.316V6h2.54v7.333zM12.7 8.667q0-1.535 1.173-2.6Q15.047 5 16.733 5q-1.687 0-2.86-1.067-1.173-1.065-1.173-2.6 0 1.535-1.173 2.6Q10.353 5 8.667 5q1.686 0 2.86 1.067 1.173 1.065 1.173 2.6"
        />
    </g>
    <defs>
        <clipPath id="IconAiAssistant_16__a">
            <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
    </defs>
</svg>
